import React, { useEffect, useState } from "react";
import { FaCircle, FaUserLock } from "react-icons/fa";
import { GoShieldLock } from "react-icons/go";
import { FaCircleQuestion } from "react-icons/fa6";
import { FiUsers } from "react-icons/fi";
import { RiLoader3Fill } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import {
  setLvl,
  setPartnersDetailsData,
  setshowcomponents,
} from "../Store/userslice";
import contAbi from "../../contracts/ContractAbi.json";
import axios from "axios";
import { useAccount, useReadContract, useWriteContract } from "wagmi";
import {
  contractAbi,
  contractAddress,
  tokenAbi,
  tokenAddress,
} from "../../contracts";
import { Bounce, toast } from "react-toastify";
import USDTimg from "../../asstes/ustd.png";
const Forsagex3Page = () => {
  const apiUrl = process.env.REACT_APP_API;
  const userdata = useSelector((state) => state.user.UserData);
  const UserAddress = userdata?.user?.userAddress || 0;
  const ActiveSlot = userdata?.user?.totalActiveSlot || 0;
  const dispatch = useDispatch();

  //------------
  const { data: hash, writeContractAsync } = useWriteContract();
  const { address, isConnected, isDisconnected } = useAccount();
  const data = [
    {
      "Lvl 1": {
        num: 10,
        partners: userdata?.partners?.[0] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 2": {
        num: 25,
        partners: userdata?.partners?.[1] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 3": {
        num: 50,
        partners: userdata?.partners?.[2] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 4": {
        num: 110,
        partners: userdata?.partners?.[3] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 5": {
        num: 225,
        partners: userdata?.partners?.[4] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 6": {
        num: 350,
        partners: userdata?.partners?.[5] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 7": {
        num: 575,
        partners: userdata?.partners?.[6] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 8": {
        num: 850,
        partners: userdata?.partners?.[7] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 9": {
        num: 1275,
        partners: userdata?.partners?.[8] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
    {
      "Lvl 10": {
        num: 2550,
        partners: userdata?.partners?.[9] || 0,
        userId: userdata?.user?.userId || 0,
      },
    },
  ];

  //------Naviget Page & Call Partners API--------
  const HandleClick = async (userId, index, num) => {
    // console.log("userId",userId)
    dispatch(setshowcomponents(1));
    dispatch(
      setLvl({
        Levels: index + 1,
        LevelAmount: num,
        UserId: userId,
      })
    );
    try {
      const response = await axios.get(
        `${apiUrl}/users/partners-details/${userId}/${index + 1}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(setPartnersDetailsData(response.data));
    } catch (error) {
      console.log("error", error);
    }
  };
  //-----------
  const [lvl, setlvl] = useState("");
  const [tnxhash, settnxhash] = useState("");
  const result = useReadContract({
    abi: contractAbi,
    address: contractAddress,
    functionName: "levelPrice",
    args: [lvl],
  });
  //----Call Approve Fution---------
  const Approve = async (index) => {
    setlvl(index + 1);
  };

  useEffect(() => {
    const performAsyncActions = async () => {
      if (address === UserAddress) {
        try {
          const app = await writeContractAsync({
            abi: tokenAbi,
            address: tokenAddress,
            functionName: "approve",
            args: [contractAddress, result.data],
          });
          if (app) {
            try {
              const openApprove = await writeContractAsync({
                abi: contAbi,
                address: contractAddress,
                functionName: "buyNewLevel",
                args: [lvl],
              });
              settnxhash(openApprove);
              console.log("openApprove");
              if (openApprove) {
                apicall();
              }
              console.log("Transaction successful:", openApprove);
            } catch (error) {
              console.log("ActiveapprovFun Error:", error);
            }
          }
        } catch (error) {
          console.log("error", error);
          toast("User rejected the request!", {
            position: "bottom-left",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        }
      } else {
        console.log("You are not owner!");
        toast("You are not owner!", {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    };
    //--------If Any Changes in Rresult.data Then run performAsyncActions---
    if (result?.data) {
      performAsyncActions();
    }
  }, [result?.data || lvl]);

  const apicall = async () => {
    const data = {
      userAddress: address,
      level: lvl,
      txnHash: tnxhash,
    };
    // --Call BuyNewLvl API-----
    try {
      const response = await axios.post(`${apiUrl}/users/buyNewLevel`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("response", response);
      console.log("response", response.data.message);
      toast(`${response.data.message}`, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="main-container-forsagex3page">
        <div className="main-div-forsagex3page">
          <div className="div-forsagex3page">
            {data.map((item, index) => {
              const levelKey = Object.keys(item)[0];
              const { num, partners, userId } = item[levelKey];
              // const isInactive = !partners;
              const isActive = index < ActiveSlot;
              return (
                <div
                  key={index}
                  className={`Lvldiv ${
                    isActive ? "Lvldiv-isActive" : "inactive"
                  }`}
                  onClick={() =>
                    isActive ? HandleClick(userId, index, num) : Approve(index)
                  }
                >
                  <div className="LvlHeader-div">
                    <div
                      className={`LvlHead${
                        isActive ? "lvl-span-isActive" : "lvl-span-inactive"
                      }`}
                    >
                      {levelKey}
                    </div>
                    <div className="LvlHeader-icon-div LvlHead">
                      <img src={USDTimg} className="span1-icon" />
                      {num}
                    </div>
                  </div>

                  {isActive ? (
                    <div className="Lvlbody">
                      <div className="lvlbox"></div>
                      <div className="lvlbox"></div>
                      <div className="lvlbox"></div>
                    </div>
                  ) : (
                    <div className="Lvlbody inactive">
                      <div className="inactive-lock-div">
                        {/* <MdLockPerson className="inactive-lock-icon"/> */}
                        <GoShieldLock className="inactive-lock-icon" />
                      </div>
                    </div>
                  )}

                  {isActive ? (
                    <div className="lvlfooter">
                      <span className="lvl-span-forsagex3page">
                        {partners !== 0 && <FiUsers />}
                      </span>
                      <span>{partners !== 0 && partners}</span>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
          <div className="forsagex3-footer">
            <span className="forsagex3-footer-span">
              <FaCircle className="FaCircle Direct-partner-icon" /> Direct
              partner
            </span>
            <span className="forsagex3-footer-span">
              <FaCircle className="FaCircle Gift" /> Gift
            </span>
            <span className="forsagex3-footer-span">
              <FiUsers className="FaCircle " /> Partners on level
            </span>
            <span className="forsagex3-footer-span">
              <RiLoader3Fill className="FaCircle " /> Levle Cycle
            </span>
            <div className="Marketing-legend">
              <span>
                <FaCircleQuestion />
              </span>
              <span>Marketing legend</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forsagex3Page;
